import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class EventProduct extends RestResource {
  active = false
  frequency = ""
  category = ""
  subCategory = ""
  exchange = ""
  externalId = ""
  name = ""
  underlyingProduct = ""
  underlyingProductType = ""
}

export const EVENT_PRODUCT_DESER: SchemaDeSer<EventProduct> =
  new SchemaDeSerBuilder(EventProduct)
    .ofBoolean("active")
    .ofString("frequency")
    .ofString("category")
    .ofString("subCategory", "sub-category")
    .ofString("exchange")
    .ofString("externalId", "external-id")
    .ofString("name")
    .ofString("underlyingProduct", "underlying-product")
    .ofString("underlyingProductType", "underlying-product-type")
    .toDeSer()
